
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SwayingGrassEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, height } = pc;
        const spacing = (30 + layerIndex * 20) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);
        const complexity = config.parallaxComplexity || 1.0;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = (2 / layerIndex) * scale;
        
        const horizon = height * 0.5;

        for (let x = x1; x <= x2; x += spacing) {
            const h = (50 + this.pseudoRandom(x) * 100) * scale * complexity;
            const sway = Math.sin(time * config.parallaxSpeed + x * 0.1) * 20 * scale;
            
            const draw = () => {
                ctx.beginPath();
                ctx.moveTo(x, horizon);
                ctx.quadraticCurveTo(x + sway * 0.5, horizon - h * 0.5, x + sway, horizon - h);
                ctx.stroke();
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
